module.exports = __webpack_public_path__ + "header-profile-skin-2.8307c45ca34d4af71912.png";


//////////////////
// WEBPACK FOOTER
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/assets/styles/patterns/header-profile-skin-2.png
// module id = ../../../../../src/assets/styles/patterns/header-profile-skin-2.png
// module chunks = styles